import { createSelector } from 'reselect';

// Base selector
const kpiGoalStateSelector = (state) => state.kpiGoal || {};

// Goals
export const goalsSelector = createSelector(
    kpiGoalStateSelector,
    (kpiGoalState) => kpiGoalState.goals || []
);

// Selected goal
export const selectedGoalSelector = createSelector(
    kpiGoalStateSelector,
    (kpiGoalState) => kpiGoalState.selectedGoal
);

// Loading state
export const loadingSelector = createSelector(
    kpiGoalStateSelector,
    (kpiGoalState) => kpiGoalState.loading || false
);

// Error
export const errorSelector = createSelector(
    kpiGoalStateSelector,
    (kpiGoalState) => kpiGoalState.error
);

// Pagination
export const paginationSelector = createSelector(
    kpiGoalStateSelector,
    (kpiGoalState) => kpiGoalState.pagination || { limit: 10, offset: 1, total: 0 }
);

// Filters
export const filtersSelector = createSelector(
    kpiGoalStateSelector,
    (kpiGoalState) => kpiGoalState.filters || { search: '', complexity: '' }
);

// Sort
export const sortSelector = createSelector(
    kpiGoalStateSelector,
    (kpiGoalState) => kpiGoalState.sort || { sortBy: 'createdAt', sortDescending: false }
);

// Dialog states
export const isGoalDialogOpenSelector = createSelector(
    kpiGoalStateSelector,
    (kpiGoalState) => kpiGoalState.isGoalDialogOpen || false
);

export const isDeleteDialogOpenSelector = createSelector(
    kpiGoalStateSelector,
    (kpiGoalState) => kpiGoalState.isDeleteDialogOpen || false
);

export const isGoalUsageDialogOpenSelector = createSelector(
    kpiGoalStateSelector,
    (kpiGoalState) => kpiGoalState.isGoalUsageDialogOpen || false
);

// Goal usage data
export const goalUsageDataSelector = createSelector(
    kpiGoalStateSelector,
    (kpiGoalState) => kpiGoalState.goalUsageData
);

// Total pages calculation
export const totalPagesSelector = createSelector(
    [paginationSelector],
    (pagination) => Math.ceil(pagination.total / pagination.limit) || 1
);

// Departments
export const departmentsSelector = createSelector(
    kpiGoalStateSelector,
    (kpiGoalState) => kpiGoalState.departments || []
);

export const departmentsLoadingSelector = createSelector(
    kpiGoalStateSelector,
    (kpiGoalState) => kpiGoalState.departmentsLoading || false
);

// Get unique departments by name (remove duplicates)
export const uniqueDepartmentsSelector = createSelector(
    [departmentsSelector],
    (departments) => {
        // Ensure departments is an array
        if (!Array.isArray(departments)) {
            return [];
        }
        
        const uniqueMap = new Map();
        departments.forEach(dept => {
            // Skip invalid entries
            if (!dept || !dept.name || !dept.id) {
                return;
            }
            
            // Only add if name doesn't exist or skip "-- --"
            if (!uniqueMap.has(dept.name)) {
                // Skip the "-- --" department
                if (dept.name !== "-- --") {
                    uniqueMap.set(dept.name, dept);
                }
            }
        });
        
        const uniqueDepts = Array.from(uniqueMap.values());
        
        return uniqueDepts.sort((a, b) => a.name.localeCompare(b.name));
    }
);
